<template>
  
    <content-header
        icona="fas fa-shopping-cart"
        titolo="Catalogo Corsi"
    ></content-header>

    <div class="card sn-card-contenuto">
        <div class="card-body">

           <!-- *** GRIGLIA CATALOGO CORSI *** -->
           <div class="card" v-if="mostraGrigliaCorsi">
                <div class="card-body">

                    <button type="button" class="btn btn-dark" @click="GetListCorsi()">
                        <i class="fas fa-sync"></i>&nbsp;
                    </button>&nbsp;
                    <button type="button" class="btn btn-success" @click="AttivaEditCorso">
                        <i class="fas fa-plus"></i>&nbsp;Nuovo Template Corso
                    </button>&nbsp;
                    <br /><br />

                   
                    
                    
                    <br/>
                    <griglia-facile
                        :colonne-header="g_colonneHeader"
                        :colonne="g_colonne"
                        :colonneNoOrder="g_colonneNoOrder"
                        :colonneAlign="g_colonneAlign"
                        :comandi="g_comandi"
                        :mostraPager="true"
                        classi-table="table-sm table-hover table-custom"
                        :dati="dtCorsi"
                        :queryLength="g_queryLength"
                        :currentPage="g_currentPage"
                        
                        @Seleziona="SelectCorso"
                        @Cancella="DelElemCorsi"
                        @Ordina="OrdinaGriglia"
                        @Prenotazioni="AttivaPrenotazioni"
                        
                        @CambiaElementi="CambiaElementi"
                        @Precedente="PaginaPrecendente"
                        @Successiva="PaginaSuccessiva"
                        @CambiaPagina="CambiaPagina"
                       

                        fontawesome="standard"

                        ></griglia-facile>

                </div>
            </div>

            <!-- *** EDIT TEMPLATE CORSO *** -->
            <div class="card" v-if="mostraEditCorso">
            <div class="card-header">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaCorso(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaCorso(false)">Salva e Chiudi</button>
            </div>
            <div class="card-body">
                

                <form autocomplete="off">

                <messaggio-standard 
                    :mostraMessaggio="mostraMessaggio"
                    :alertClass="alertClass"
                    :alertIcon="alertIcon"
                    :alertIconSpin="alertIconSpin"
                    :alertMessaggio="alertMessaggio"
                    fontawesome="standard"
                    ></messaggio-standard>
                    
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-info text-primary"></i>&nbsp;Dati generali
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-2 mb-3">
                        <label class="form-label">Tipo Corso</label>
                        <select v-model="oCorso.cct_idTipo" class="form-select">
                            <option value="1">Profitto</option>
                            <option value="2">Partecipazione</option>
                        </select>
                    </div>
                    
                </div>

                <div class="row">
                    <div class="col-md-12 mb-3">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" v-model="oCorso.cct_visibile">
                            <label class="form-check-label" for="flexSwitchCheckDefault">Visibilià corso (se attivato il corso è visibile pubblicamente)</label>
                        </div>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label">Titolo Corso</label>
                    <input type="text" v-model="oCorso.cct_titolo" class="form-control" placeholder="Inserisci il titolo del corso">
                </div>

                <div class="mb-3">
                    <label class="form-label">Descrizione Corso</label>
                    <textarea v-model="oCorso.cct_descrizione" class="form-control" rows="3" placeholder="Inserisci la descrizione del corso"></textarea>
                </div>

                <div class="row">
                    <div class="col-md mb-3">
                        <label class="form-label">Numero Partecipanti minimo</label>
                        <input type="number" v-model="oCorso.cct_npartecipanti_min" class="form-control" placeholder="Inserisci il numero di partecipanti minimo">
                    </div>

                    <div class="col-md mb-3">
                        <label class="form-label">Numero Partecipanti massimo</label>
                        <input type="number" v-model="oCorso.cct_npartecipanti_max" class="form-control" placeholder="Inserisci il numero di partecipanti massimo">
                    </div>
                </div>


                </form>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaCorso(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaCorso(false)">Salva e Chiudi</button>
            </div>
            </div>



            <!-- *** VISUALIZZA PRENOTAZIONI *** -->
            <div class="card" v-if="mostraPrenotazioni">
            <div class="card-header">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
            </div>
            <div class="card-body">

                <button type="button" class="btn btn-dark" @click="GetListCorsiPrenotazioni(idCctInPrenotazioni)">
                    <i class="fas fa-sync"></i>&nbsp;
                </button>&nbsp;
                <button type="button" class="btn btn-success" @click="CalendarizzaNuovo">
                    <i class="fas fa-calendar-alt"></i>&nbsp;Calendarizza e avvia Corso
                </button>&nbsp;
                <!-- <button type="button" class="btn btn-success" @click="CalendarizzaEsistente">
                    <i class="fas fa-calendar-alt"></i>&nbsp;Calendarizza su Corso esistente
                </button>&nbsp; -->
                <br /><br />

                <!-- **** GRIGLIA CORSI PRENOTATI **** -->
                <table class="table table-sm table-custom">
                    <thead>
                        <tr>
                            <th>Scegli</th>
                            <th>Id. pren.</th>
                            <th>Cliente</th>
                            <th>Data Prenotazione</th>
                            <th>Part. rich./iscr.</th>
                            <th>Stato</th>
                            <th>Note</th>
                            <th><i class="fas fa-bars fa-fw"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="p, i in dtCorsiPrenotazioni" :key="i">
                            <td>
                                <template v-if="p.cpr_stato == 5">
                                    <input type="checkbox" v-model="p.selected" >
                                </template>
                            </td>
                            <td>{{ p.cpr_id }}</td>
                            <td>{{ p.ana_ragioneSociale }}</td>
                            <td>{{ FormattaData(p.cpr_dtaPrenota) }}</td>
                            <td>{{ p.cpr_npartecipanti }} / 
                                <span v-if="p.partecIscritti == p.cpr_npartecipanti" >{{ p.partecIscritti }}</span>
                                <span v-else style="color: red;">{{ p.partecIscritti }}</span>
                                <template v-if="p.partecIscritti > 0">
                                    <a href="#j" @click="MostraPartecipanti(p.cpr_id)"><i class="fas fa-users fa-fw ms-2"></i></a>
                                </template>
                            </td>
                            <td>{{ p.cps_descrizione }}</td>
                            <td>{{ p.cpr_note }}</td>
                            <td>
                                <!-- <button type="button" class="btn btn-sm btn-outline-primary" title="Modifica" @click="EditPersonale(p.cpr_id)"><i class="fas fa-edit" title="Edit"></i></button>&nbsp; -->
                                <!-- approva -->
                                <button type="button" v-if="p.cpr_stato ==1" class="btn btn-sm btn-outline-primary me-2" title="Approva" @click="ApprovaCorsiPrenotazioni(p.cpr_id)"><i class="fas fa-stamp fa-fw"></i></button>
                                <!-- rifiuta -->
                                <button type="button" v-if=" p.cpr_stato !=2" class="btn btn-sm btn-outline-warning me-2" title="Rifiuta" @click="AnnullaCorsiPrenotazioni(p.cpr_id)"><i class="fas fa-ban fa-fw"></i></button>
                                <!-- cancella -->
                                <button type="button" v-if="p.cpr_stato ==3 | p.cpr_stato ==2" class="btn btn-sm btn-outline-danger me-2" title="Cancella" @click="DelCorsiPrenotazioni(p.cpr_id)"><i class="fas fa-trash fa-fw"></i></button>
                                
                            </td>
                        </tr>
                    </tbody>
                </table>
               

               
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
            </div>
            </div>

        </div>
    </div>

    <!-- *** DIALOG MOSTRA PARTECIPANTI *** -->
    <dialog class="dialogMostraPartec">
        <div class="d-flex mb-3" style="border-bottom:solid 1px #ccc" >
            <div class="">
                <i class="fas fa-users text-primary"></i>
            </div>
            <div class="ms-2">
                <h5>Partecipanti iscritti</h5>
            </div>
        </div>

        <table class="table table-sm table-custom">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Cognome</th>
                    <th>Nome</th>
                    <th>CF</th>
                    <th>Email</th>
                    <th><i class="fas fa-bars fa-fw"></i></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="pa, i in dtPartecCorso" :key="i">
                    <td>{{ pa.per_id }}</td>
                    <td>{{ pa.per_cognome }}</td>
                    <td>{{ pa.per_nome }}</td>
                    <td>{{ pa.per_cf }}</td>
                    <td>{{ pa.per_email }}</td>
                    <td>
                        
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-outline-dark me-2" @click="ChiudiMostraPartecipanti">Chiudi</button>
        </div>


    </dialog>

    <!-- *** DIALOG CALENDARIZZA CORSO *** -->
    <dialog class="dialogCalendarizzaNuovo">
        <div class="d-flex mb-3" style="border-bottom:solid 1px #ccc" >
            <div class="">
                <i class="fas fa-chalkboard-teacher text-primary"></i>
            </div>
            <div class="ms-2">
                <h5>Calendarizza corso</h5>
            </div>
        </div>

        Scegliere un corso esistente oppure uno nuovo<br />
        <select class="form-control" v-model="corsoDaCalendarizzare" >
            <option value="-1">CREA NUOVO CORSO</option>
            <option v-for="c, ic in dtCorsiAperti"  :key="ic" :value="c.cor_id">
                [{{ c.cor_codice }}] - {{ c.cor_titolo }}; part. {{ c.npartecipanti }} di {{ c.cor_npartecipanti_max }}
            </option>
        </select>
        <br /><br />

        Verificare l'elenco dei partecipanti.<br />
        <table class="table table-sm table-custom">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Cognome</th>
                    <th>Nome</th>
                    <th>CF</th>
                    <th>Email</th>
                    <th>Cliente</th>
                    <th><i class="fas fa-bars fa-fw"></i></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="pa, i in dtPartecCorsoCalendar" :key="i">
                    <td>{{ pa.per_id }}</td>
                    <td>{{ pa.per_cognome }}</td>
                    <td>{{ pa.per_nome }}</td>
                    <td>{{ pa.per_cf }}</td>
                    <td>{{ pa.per_email }}</td>
                    <td>{{ pa.ana_ragioneSociale }}</td>
                    <td>
                        
                    </td>
                </tr>
            </tbody>
        </table>

       
        

        <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-outline-dark me-2" @click="ChiudiCalendarizzaNuovo">Annulla</button>
            <button type="button" class="btn btn-outline-primary me-2" @click="AvviaCorso">Conferma e avvia corso</button>
        </div>


    </dialog>




    <iframe id="iFrameDn" name="iFrameDn" src="about:blank" style="display:none"></iframe> 
    
</template>

<script>
import GrigliaFacile from '@/components/GrigliaFacile.vue';
import snFunctions from '@/lib/snFunctions.js';
import ContentHeader from '@/components/layout/ContentHeader.vue';
import MessaggioStandard from '@/components/MessaggioStandard.vue';

export default {
    name: 'CorsiCatalogoView',
    components: {
        ContentHeader, GrigliaFacile, MessaggioStandard
    },
    inject: ['cfg'],
    data: function() {
        return {
            dtCorsi: [],
            dtPartecipanti: [],
            dtClienti: [],
            dtCorsiStati: [],
            dtCorsiPrenotazioni: [],
            dtPartecCorso: [],
            dtPartecCorsoCalendar: [],
            dtCorsiAperti: [],

            //Impostazioni griglia CORSI
            g_colonne: ['cct_id', 'vis_tipo', 'cct_titolo', 'vis_visibile', 'nPrenotazioni'],
            g_colonneHeader: ['Id', 'Tipo', 'Titolo', 'Visibile', 'Prenotazioni'],
            g_colonneNoOrder: ['vis_tipo', 'vis_visibile'], 
            g_colonneAlign: [
                {column: 'nPrenotazioni', align: 'text-center'}, 
            ],
            g_comandi: 
            [
                {titolo:'Cancella', icona:'fa-trash', iconaStile: 'btn btn-xs btn-outline-danger', emetti: 'Cancella'},
                {titolo:'Prenotazioni', icona:'fa-shopping-cart', iconaStile: 'btn btn-xs btn-outline-primary', emetti: 'Prenotazioni'},
                // {titolo:'Archivio', icona:'fa-archive', iconaStile: 'btn btn-xs btn-outline-warning', emetti: 'Archivio'},
                // {titolo:'Duplica', icona:'fa-clone', iconaStile: 'btn btn-xs btn-outline-primary', emetti: 'Duplica'},
            ],
            g_queryLength: 0, //lunghezza della query (che NON è la lunghezza del dataset passato)
            g_currentPage: 1, //pagina corrente

            //Oggetto richiesta griglia
            reqGrigliaCorsi: {
                ele_pag: 10,
                start: 0,
                orderColumn: "cct_titolo",
                orderDir:"ASC",
                token: this.$store.state.UserInfo.token,
                //Campi custom
                Testuale: "",
                
            },

            oCorso: {
                cct_id: -1,
                cct_idTipo: -1,
                cct_idCat: -1,
                cct_titolo: "",
                cct_descrizione: "",
                cct_npartecipanti_min: 0,
                cct_npartecipanti_max: 0,
                cct_visibile: false,

                token: "",
            },

            corsoDaCalendarizzare: -1,

            idCctInPrenotazioni: -1,


            mostraGrigliaCorsi: true,
            mostraEditCorso: false,
            mostraPrenotazioni: false,

            mostraMessaggio: false,
            alertMessaggio: "",
            alertClass: "",     
            alertIcon: "",
            alertIconSpin: false
           
        
        }
    },
    methods: {
        // GESTIONE PANNELLI E PULIZIA INPUT
        AttivaGriglia() {
            this.mostraEditCorso = false;
            this.mostraGrigliaCorsi = true;
            this.mostraPrenotazioni = false;

            this.GetListCorsi();
        },
        AzzeraFiltri() {
            this.reqGrigliaCorsi.Testuale = "";
            this.GetListCorsi();
        },
        AttivaEditCorso() {
            this.mostraEditCorso = true;
            this.mostraGrigliaCorsi = false;
            this.mostraPrenotazioni = false;
            
            this.ClearMessaggio();
            this.ClearCorso();

        },
        AttivaPrenotazioni(e) {
            this.AttivaPrenotazioniById(e.cct_id);
        },
        AttivaPrenotazioniById(id) {
            this.mostraEditCorso = false;
            this.mostraGrigliaCorsi = false;
            this.mostraPrenotazioni = true;
            
            this.idCctInPrenotazioni = id;
            this.GetListCorsiPrenotazioni(id);
        },

        ClearCorso() {
            this.oCorso = {
                cct_id: -1,
                cct_idTipo: -1,
                cct_idCat: -1,
                cct_titolo: "",
                cct_descrizione: "",
                cct_npartecipanti_min: 0,
                cct_npartecipanti_max: 0,
                cct_visibile: false,
                                
                token: "",
            }
        },
        ClearMessaggio() {
            this.mostraMessaggio = false;
            this.alertMessaggio =  "";
            this.alertClass = "";
            this.alertIcon = "";
            this.alertIconSpin = false;
        },
        
       // *** OPERAZIONI DI BASE SU CORSI (CATALOGO)
        GetListCorsi() {
            //Carica lista elementi
            this.$store.commit('Messaggio', {parms: [true, ['Caricamento griglia in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/CorsiCatalogo/GetListCorsiCatalogo" , {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.reqGrigliaCorsi)
            }).then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Griglia caricata.'], 'alert alert-success', 'fa-check', false, 2000]});
                
                        for(let i = 0; i<obj.moreJsonData.length; i++){
                            
                            //Formatta il tipo
                            if(obj.moreJsonData[i].cct_idTipo == 1) {
                                obj.moreJsonData[i].vis_tipo = "<i class='fas fa-certificate fa-sm fa-fw text-danger'></i>&nbsp;" + obj.moreJsonData[i].cot_descrizione;
                            } else { 
                                obj.moreJsonData[i].vis_tipo = "<i class='fas fa-handshake fa-sm fa-fw text-info'></i>&nbsp;" + obj.moreJsonData[i].cot_descrizione;
                            }

                            //Formatta il campo visibile
                            if(obj.moreJsonData[i].cct_visibile == true) {
                                obj.moreJsonData[i].vis_visibile = "<i class='fas fa-eye fa-sm fa-fw text-primary'></i>";
                            } else { 
                                obj.moreJsonData[i].vis_visibile = "<i class='fas fa-eye-slash fa-sm fa-fw text-dark'></i>";
                            }

                            
                        }

                        this.dtCorsi = obj.moreJsonData;
                        this.g_queryLength = parseInt(obj.dati[0], 10);
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, ['Errore caricamento griglia.'], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                });
        },
        GetElemCorsi(idelem) {
            //Carica elemento singolo
            fetch(this.cfg.apisrv + "/api/CorsiCatalogo/GetElemCorsiCatalogo?token=" + this.$store.state.UserInfo.token + "&idCor=" + idelem)
            .then(response => response.json())
            .then(obj => {

                this.oCorso = obj;

                this.mostraGrigliaCorsi=false;
                this.mostraEditCorso= true;

                this.$store.commit('Messaggio', {parms: [true, ['Corso caricato.'], 'alert alert-success', 'fa-check', false, 2000]});

            });
        },
        //Esporta su Excel
        EsportaListaCorsi() {
            let qy = "?token=" + this.$store.state.UserInfo.token + 
                    "&orderColumn=" + this.reqGrigliaCorsi.orderColumn + "&orderDir=" + this.reqGrigliaCorsi.orderDir +
                    "&Testuale=" + this.reqGrigliaCorsi.Testuale;
            let url =this.cfg.apisrv + "/api/CorsiCatalogo/EsportaListaCorsi" + qy;
            let iFrameDn = document.getElementById("iFrameDn");
            iFrameDn.src = url;
          
        },
        //modifica corso 
        SelectCorso(o)  {
            this.GetElemCorsi(o.cct_id);
        },

        SalvaCorso(reload) {
            let oSubmit = [];
            oSubmit = this.oCorso;
            oSubmit.token = this.$store.state.UserInfo.token;
                  
            this.ClearMessaggio();
            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/CorsiCatalogo/SalvaCorsiCatalogo", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                        if(reload)  {
                            this.GetElemCorsi(obj.dati[0]);
                        }
                        else {
                            //Fa redirect
                            this.AttivaGriglia();
                        }
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});

                        this.mostraMessaggio = true;
                        this.alertMessaggio = obj.dati;
                        this.alertClass = "alert alert-warning";
                        this.alertIcon = "fa-xmark"
                        this.alertIconSpin = false
                    }
                });

        },

        DelElemCorsi(e) {
            //Cancella elemento singolo
            if(confirm("Cancellare l'elemento?")) {
                fetch(this.cfg.apisrv + "/api/CorsiCatalogo/DelElemCorsiCatalogo?token=" + this.$store.state.UserInfo.token + "&idCor=" + e.cct_id)
                .then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Eliminato'], 'alert alert-success', 'fa-check', false, 2000]});
                        this.GetListCorsi(); 
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                    
                });
            }

        },

        // *** OPERAZIONI SU PRENOTAZIONI
        GetListCorsiPrenotazioni(idCct) {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/GetListCorsiPrenotazioni?token=" + this.$store.state.UserInfo.token + "&idCct=" + idCct)
                .then(response => response.json())
                .then(obj => {
                    this.dtCorsiPrenotazioni = obj;
                });
        },
        AnnullaCorsiPrenotazioni(idelem) {
            if(confirm("Rifiutare questa prenotazione?")) {
                fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/AnnullaCorsiPrenotazioni?token=" + this.$store.state.UserInfo.token + "&idCpr=" + idelem)
                .then(response => response.json())
                .then(obj => {
                    this.GetListCorsiPrenotazioni(this.idCctInPrenotazioni);
                });
            }

        },
        DelCorsiPrenotazioni(idelem) {
            if(confirm("Cancellare questa prenotazione?")) {
                fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/DelElemCorsiPrenotazioni?token=" + this.$store.state.UserInfo.token + "&idCpr=" + idelem)
                .then(response => response.json())
                .then(obj => {
                    this.GetListCorsiPrenotazioni(this.idCctInPrenotazioni);
                });
            }

        },

        ApprovaCorsiPrenotazioni(idelem) {
            if(confirm("Approvare questa prenotazione?")) {
                fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/ApprovaCorsiPrenotazioni?token=" + this.$store.state.UserInfo.token + "&idCpr=" + idelem)
                .then(response => response.json())
                .then(obj => {
                    this.GetListCorsiPrenotazioni(this.idCctInPrenotazioni);
                });
            }

        },

        // *** CALENDARIZZAZIONE *** //

        CalendarizzaNuovo() {

            this.corsoDaCalendarizzare = -1;

            this.dtPartecCorsoCalendar = [];
            for(let i = 0; i< this.dtCorsiPrenotazioni.length; i++) {
                if(this.dtCorsiPrenotazioni[i].selected) {
                    fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/GetListPartecipanti?token=" + this.$store.state.UserInfo.token + "&idCpr=" + this.dtCorsiPrenotazioni[i].cpr_id)
                    .then(response => response.json())
                    .then(obj => {
                        //aggiunge i partecipanti
                        for(let p = 0; p<obj.length; p++) {
                            this.dtPartecCorsoCalendar.push(obj[p]);
                        }
                    });      
                }

            }
            const dialog = document.querySelector(".dialogCalendarizzaNuovo");
            dialog.showModal();


            
        },
        ChiudiCalendarizzaNuovo() {
            const dialog = document.querySelector(".dialogCalendarizzaNuovo");
            dialog.close();
        },

       
        AvviaCorso() {
            //raccoglie gli idCpr da calendarizzare come corso
            let aCpr = [];
            for(let i = 0; i< this.dtCorsiPrenotazioni.length; i++) {
                if(this.dtCorsiPrenotazioni[i].selected) {
                    aCpr.push(this.dtCorsiPrenotazioni[i].cpr_id);
                }
            }

            //this.$router.push({ name: 'corsi', query: { edit: aCpr.toString() } });

            fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/CalendarizzaCorso?token=" + this.$store.state.UserInfo.token + "&ids=" + aCpr + "&idCor=" + this.corsoDaCalendarizzare)
                .then(response => response.json())
                .then(obj => {
                    
                    const dialog = document.querySelector(".dialogCalendarizzaNuovo");
                    dialog.showModal();

                    //Apre il corso creato
                    //this.$router.push("/corsi/" + obj.dati[0]);
                    this.$router.push({ name: 'corsi', query: { edit: obj.dati[0] } });


                });    
        },

        // *** DIALOG MOSTRA PARTECIPANTI *** //
        MostraPartecipanti(idCpr) {
            fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/GetListPartecipanti?token=" + this.$store.state.UserInfo.token + "&idCpr=" + idCpr)
                .then(response => response.json())
                .then(obj => {
                    this.dtPartecCorso = obj;

                    const dialog = document.querySelector(".dialogMostraPartec");
                    dialog.showModal();


                });            
        },
        ChiudiMostraPartecipanti() {
            const dialog = document.querySelector(".dialogMostraPartec");
            dialog.close();
        },

        // *** CARICAMENTO TABELLE SERVIZIO
        GetListClienti() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/AnagraficaClienti/GetListAnagraficaClienti?token=" + this.$store.state.UserInfo.token + "&full=no")
                .then(response => response.json())
                .then(obj => {
                    this.dtClienti = obj;
                });
        },
        GetListCorsiStati() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/CorsiStati/GetListCorsiStati?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtCorsiStati = obj;
                });
        },
        GetListCorsiAperti() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Corsi/GetListCorsiAperti?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtCorsiAperti = obj;
                });
        },
    

        //PAGINAZIONE GRIGLIA
        CambiaElementi(nrElem) {
            this.reqGrigliaCorsi.ele_pag = nrElem;
            this.GetListCorsi();
        },
        PaginaPrecendente() {
            this.reqGrigliaCorsi.start = this.reqGrigliaCorsi.start - parseInt(this.reqGrigliaCorsi.ele_pag, 10);
            this.g_currentPage--;
            this.GetListCorsi();  
        
        },
        PaginaSuccessiva() {
            this.reqGrigliaCorsi.start = this.reqGrigliaCorsi.start + parseInt(this.reqGrigliaCorsi.ele_pag, 10);
            this.g_currentPage++;
            this.GetListCorsi();
        
        },
        CambiaPagina(pag) {
            this.reqGrigliaCorsi.start = (parseInt(this.reqGrigliaCorsi.ele_pag, 10) * pag) - parseInt(this.reqGrigliaCorsi.ele_pag, 10);
            this.g_currentPage = pag;
            this.GetListCorsi();
        },

        // ORDINA LA GRIGLIA
        OrdinaGriglia(i) {
            if(this.reqGrigliaCorsi.orderColumn == this.g_colonne[i]) {
                //Stessa colonna
                if(this.reqGrigliaCorsi.orderDir == 'DESC') {this.reqGrigliaCorsi.orderDir = 'ASC';}
                else {this.reqGrigliaCorsi.orderDir = 'DESC';}
            }
            else {
                //altra colonna
                this.reqGrigliaCorsi.orderColumn = this.g_colonne[i];
                this.reqGrigliaCorsi.orderDir = 'DESC';
                
            }
            
            this.GetListCorsi();

        },

        /* *** ALTRE FUNZIONI *** */
        FormattaData(dta) {
            return snFunctions.dateFormat(dta, "dd-MM-yyyy");
        },
    
    },
    computed: {
        
    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.GetListCorsi();
        this.GetListClienti();
        this.GetListCorsiStati();
        this.GetListCorsiAperti();

        if(this.$route.query.idCat !=  undefined) {
            this.AttivaPrenotazioniById(this.$route.query.idCat);
        }


        

             

    }
}
</script>